import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=3608550e&"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmtkpv/Projects/barcode-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3608550e', component.options)
    } else {
      api.reload('3608550e', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=3608550e&", function () {
      api.rerender('3608550e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/loader.vue"
export default component.exports